module.exports = __webpack_public_path__ + "d00d37d2486026cb088d67ba2bb581d9.svg";